import * as types from './mutations-type.js';
import _ from 'lodash';

export default {
    [types.SET_LOADING](state, data) {
        state.loading = data;
    },
    [types.SET_LOADING_SELLERS](state, data) {
        state.loadingSellers = data;
    },
    [types.SET_LOADING_CONTRACTS](state, data) {
        state.loadingContracts = data;
    },
    [types.SET_DATA_STOCK](state, data) {
        _.forEach(data.totalsByLocations, (dataByLocation) => {
            state.totalsByLocations.push(dataByLocation);
        });
        state.totalsByLocations = _.orderBy(state.totalsByLocations, (dataByLocation) => {
            return dataByLocation.storageDevice.control_label;
        });
        state.totalsByProducts = data.totalsByProducts;
        state.generalTotals = data.generalTotals;
    },
    [types.SET_RECALCULATE_STOCK_INFO](state, data) {
        state.reCalculateInfo = data
    },

    // charts
    [types.SET_DATASETS](state, data) {
        state.datasets = data;
    },
    [types.SET_CHART](state, data) {
        state.chart = data;
    },
    [types.SET_ITEM_IN_SHEET](state, data) {
        state.itemInSheet = data;
    },

    // sheet
    [types.SET_SHEET_SELLER](state, data) {
        state.sheetSeller = data;
    },
    [types.SET_SHEET_CONTRACT](state, data) {
        state.sheetContract = data;
    },

    // contracts
    [types.SET_DATA_CONTRACTS](state, data) {
        state.contracts = data.content;
        state.totalContracts = data.totalElements;
    },
    [types.SET_CONTRACTS_NAMES](state, data) {
        state.contractsNames = data;
    },

    //sellers
    [types.SET_DATA_SELLERS](state, data) {
        state.sellers = data;
    },
    [types.SET_SELLERS_NAMES](state, data) {
        state.sellersNames = data;
    },

    //volumes & quebra
    [types.SET_QUEBRA](state, data) {
        state.quebra = data;
    },
    [types.SET_VOLUMES_NEGOTIATE](state, data) {
        state.volumesN = data;
    },
    [types.SET_VOLUMES_BENEFIT](state, data) {
        state.volumesB = data;
    },


    [types.SET_RECORDS](state, data) {
        state.records = data.content;
        state.totalRecordsFromServer = data.totalElements;
    },
    [types.SET_INSPECTIONS](state, data) {
        state.inspections = data.content;
        state.totalInspectionsFromServer = data.totalElements;
    },
    [types.SET_DOCUMENTS](state, data) {
        state.documents = data.content;
        state.totalDocumentsFromServer = data.totalElements;
    },
    [types.SET_BIORGANIC](state, data) {
        state.biorganic = data;
    },

    [types.SET_TRACEABILITY](state, data) {
        state.traceability = data.content;
        state.totalRTFromServer = data.totalElements;
    },

    [types.SET_QR_LIST](state, data) {
        state.qrList = data.content;
        state.totalQRFromServer = data.totalElements;
    },

    [types.SET_QAP_REPORTS_LIST](state, data) {
        state.customReportsList = data.content;
        state.totalCustomFromServer = data.totalElements;
    },

    [types.SET_TRACEABILITYV2](state, data) {
        state.traceabilityV2 = data;
    },

    [types.SET_RECORDS_ORIGINAL_STATE](state) {
        state.records = [];
        state.totalRecordsFromServer = null
    },
    [types.SET_INSPECTIONS_ORIGINAL_STATE](state) {
        state.inspections = [];
        state.totalInspectionsFromServer = null
    },
    [types.SET_DOCUMENTS_ORIGINAL_STATE](state) {
        state.documents = [];
        state.totalDocumentsFromServer = null
    },
    [types.SET_BIORGANIC_ORIGINAL_STATE](state) {
        state.biorganic = [];
        state.totalBiorganicFromServer = null
    },
    [types.SET_TRACEABILITY_ORIGINAL_STATE](state) {
        state.traceability = [];
        state.totalRTFromServer = null
    },
    [types.SET_QAP_REPORTS_ORIGINAL_STATE](state) {
        state.customReportsList = [];
        state.totalCustomFromServer = null
    },
    [types.SET_TRACEABILITYV2_ORIGINAL_STATE](state) {
        state.traceabilityV2 = [];
        state.totalTraceabilityV2FromServer = null
    },

    [types.SET_RECORDS_BY_IDS](state, payload) {
        state.recordsByIds = payload;
    },
    [types.SET_RECORDS_BY_IDS_ORIGINAL_STATE](state) {
        state.recordsByIds = [];
    },

    [types.SET_SOURCE](state, data) {
        state.source = data;
    },
    [types.SET_REQUEST](state, data) {
        state.request = data;
    },

    [types.SET_HEADERS_TRACEABILITY](state, data) {
        state.headersTraceability = data;
    },

    [types.SET_CUSTOM_REPORTS_LIST](state, data) {
        state.customReportsList = data.content || [];
        state.totalCustomFromServer = data.totalElements || 0;
    },
    
    [types.SET_TOTAL_CUSTOM_FROM_SERVER](state, total) {
        state.totalCustomFromServer = total;
    },

    // ===============================
    // WHATSAPP/EMAIL REPORT SHARING MUTATIONS
    // ===============================
    [types.SET_REPORT_FILES_LIST](state, data) {
        state.reportFilesList = data.content || [];
        state.totalReportFilesFromServer = data.totalElements || 0;
    },

    [types.SET_TOTAL_REPORT_FILES_FROM_SERVER](state, total) {
        state.totalReportFilesFromServer = total;
    },

    [types.SET_REPORT_TYPES](state, data) {
        state.reportTypes = data || [];
    },

    [types.SET_SHARED_REPORTS_LIST](state, data) {
        console.log('SET_SHARED_REPORTS_LIST mutation called with:', data);
        state.sharedReportsList = data.content || [];
        state.totalSharedReportsFromServer = data.totalElements || 0;
    },

    [types.SET_TOTAL_SHARED_REPORTS_FROM_SERVER](state, total) {
        state.totalSharedReportsFromServer = total;
    },

    [types.SET_RECIPIENTS_LIST](state, data) {
        console.log('SET_RECIPIENTS_LIST mutation called with:', data);
        state.recipientsList = data || [];
    },

    [types.SET_SHARED_REPORT_DETAILS](state, data) {
        console.log('=== SET_SHARED_REPORT_DETAILS MUTATION ===');
        console.log('Received data:', data);
        console.log('Type of data:', typeof data);
        console.log('Is array:', Array.isArray(data));
        
        // Según la especificación, data es un objeto con recipients anidados
        // Extraemos los recipients para usarlos en el componente SharingDetailsPanel
        if (data && data.recipients && Array.isArray(data.recipients)) {
            console.log('Using data.recipients (array length:', data.recipients.length, ')');
            state.sharedReportDetails = data.recipients;
        } else if (Array.isArray(data)) {
            console.log('Using data as array (length:', data.length, ')');
            // Fallback si viene como array
            state.sharedReportDetails = data;
        } else {
            console.log('No valid data structure, setting empty array');
            state.sharedReportDetails = [];
        }
        console.log('=== FINAL sharedReportDetails in state ===');
        console.log('Final sharedReportDetails stored:', state.sharedReportDetails);
        console.log('Length:', state.sharedReportDetails.length);
    },

    [types.SET_LOADING_REPORT_SHARING](state, loading) {
        state.loadingReportSharing = loading;
    },
}
